import {axiosInstance} from "../../utils/axios";
import {Language} from "../models/language";

export async function fetchLanguages(): Promise<Language[]> {
  return axiosInstance.get("/languages").then((resp) => resp.data);
}
